/**
 * 카테고리 Visibility 상수에대해 정의한다.
 */

// 공개 ID
export const PUBLIC = 20;

// 비공개 ID
export const PRIVATE = 0;

// 공개 ID
export const PUBLIC_STRING = 'PUBLIC';

// 비공개 ID
export const PRIVATE_STRING = 'PRIVATE';

// 공개 Label
export const LABEL_PUBLIC = "공개";
// 비공개 Label
export const LABEL_PRIVATE = "비공개";

/**
 * 카테고리 VisibilityList
 * @type {*[]}
 */
export const List = [PUBLIC, PRIVATE];

/**
 *
 * @param visibility
 * @returns {string}
 */
export const getLabelByVisibility = (visibility) => {
  switch (visibility) {
    case PRIVATE :
      return LABEL_PRIVATE;

    case PUBLIC :
    default :
      return LABEL_PUBLIC;
  }
};


/**
 * 비공개
 * @param visibility
 * @returns {*}
 */
export const isPrivate = (visibility) => {
  return (visibility === PRIVATE || visibility === PRIVATE_STRING);
};


/**
 * 공개
 * @param visibility
 * @returns {*}
 */
export const isPublic = (visibility) => {
  return !isPrivate(visibility);
};





